import request from '../utils/request'

/**
 * 创建配音订单
 * @param {Object} data
 */
export function createDubOrder (data) {
  return request({
    url: '/order/create_dubbing_order',
    method: 'post',
    data
  })
}

/**
 * 列出所有配音订单
 * @param {Object} data
 */
export function listDubOrder (data) {
  return request({
    url: '/order/list_dubbing_order/v2',
    method: 'post',
    data
  })
}

/**
 * 删除配音订单
 * @param {Object} data
 */
export function delDubOrder (data) {
  return request({
    url: '/order/delete_dubbing_order',
    method: 'post',
    data
  })
}

/**
 * 多选删除配音作品
 * @param {Object} data
 */
 export function delDubOrderArray (data) {
  return request({
    url: '/order/user_delete_dubbing_order',
    method: 'post',
    data
  })
}

/**
 * 创建vip订单
 * @param {Object} data
 */
export function createVipOrder (data) {
  return request({
    url: '/order/create_vip_order',
    method: 'post',
    data
  })
}

/**
 * 删除vip订单
 * @param {Object} data
 */
export function delVipOrder (data) {
  return request({
    url: '/order/delete_vip_order',
    method: 'post',
    data
  })
}

/**
 * 查询订单状态
 * @param {Object} data
 */
export function checkOrderStatus (data) {
  return request({
    url: '/order/check_order_status',
    method: 'post',
    data
  })
}

/**
 * 创建配音包订单
 * @param {String} id
 * @return trade_no
 */
export function createDubbingPackageOrder (data) {
  return request({
    url: '/order/create_dubbing_package_order',
    method: 'post',
    data
  })
}

/**
 * 创建钱包提现订单
 * @param {String} id
 * @return trade_no
 */
export function createWithdrawalMoneyOrder (data) {
  return request({
    url: '/order/create_withdrawal_money_order',
    method: 'post',
    data
  })
}

/**
 * 获取微信支付二维码 支付结果
 * @param {String} trade_no
 * @return code
 */
 export function checkNativeOrderStatus (data) {
  return request({
    url: '/order/check_order_payment_status',
    method: 'post',
    data
  })
}
